import React from 'react';
import { Link } from 'react-router-dom';
import './styles/CTAButton.css';

function CTAButton({ text, to }) {
  if (to) {
    return (
      <Link to={to} className="cta-button">
        {text}
      </Link>
    );
  }
  
  return (
    <button className="cta-button">
      {text}
    </button>
  );
}

export default CTAButton;
